import * as React from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { VisibleCompanyDataModel } from "../common/models/CommonModels";
import Typography from '@material-ui/core/Typography';
import { localizations } from '../localization/localization';
import { ApplicationState } from '../store';
import ZeckitLargeWidget from '../common/ZeckitLargeWidget';
import { getValidLink } from '../utils/uriParsing';
import CompanyActivityMark from '../common/companyActivityMark';
import GoldIcon from "../images/gold.svg";
import SilverIcon from "../images/silver.svg";
import BronzeIcon from "../images/bronze.svg";

type CompanyCardProps = VisibleCompanyDataModel;

const CompanyInfo = (props: CompanyCardProps) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td className="title">{localizations.common.companyName}</td>
                    <td>{props.name}</td>
                </tr>
                <tr>
                    <td className="title">{localizations.common.businessId}</td>
                    <td>{props.businessId}</td>
                </tr>
                {props.website ? 
                <tr>
                    <td className="title">{localizations.common.website}</td>
                    <td><a href={getValidLink(props.website)} target="_blank">{props.website}</a></td>
                </tr>
                : null}
                {props.contact && props.contact.phoneNumber ? 
                <tr>
                    <td className="title">{localizations.common.phoneNumber}</td>
                    <td>
                        <span>{props.contact.phoneNumber}<br /></span>
                        {props.contact.phoneDetails && props.contact.phoneDetails.length > 0 ? <span>{props.contact.phoneDetails}</span> : null}
                    </td>
                </tr>
                : null}
                {props.contact && props.contact.email ? 
                <tr>
                    <td className="title">{localizations.common.email}</td>
                    <td>
                        <span>{props.contact.email}<br /></span>
                        {props.contact.emailDetails && props.contact.emailDetails.length > 0 ? <span>{props.contact.emailDetails}</span> : null}
                    </td>
                </tr>
                : null}
                {props.contactPerson && props.contactPerson ? 
                <tr>
                    <td className="title" style={{ verticalAlign: "top" }}>{localizations.common.contactPerson}</td>
                    <td >
                        {props.contactPerson.firstName} {props.contactPerson.lastName} <br />
                        {props.contactPerson.contact && props.contactPerson.contact.email ? toEmail(props.contactPerson.contact.email || "") : null}
                        {props.contactPerson.contact && props.contactPerson.contact.emailDetails ? <span><i>{props.contactPerson.contact.emailDetails}</i><br /></span> : null}
                        {props.contactPerson.contact && props.contactPerson.contact.phoneNumber ? <span>{props.contactPerson.contact.phoneNumber}<br /></span> : null}
                        {props.contactPerson.contact && props.contactPerson.contact.phoneDetails ? <span><i>{props.contactPerson.contact.phoneDetails}</i><br /></span> : null}
                    </td>
                </tr>
                : null}
                {props.address ?
                <tr>
                    <td className="title">{localizations.common.streetAddress}</td>
                    <td>{props.address.streetAddress} <br /> {`${props.address.postalCode} ${props.address.city}`}</td>
                </tr>
                : null}
                {props.industryType ?
                <tr>
                    <td className="title">{localizations.company.companyIndustryType}</td>
                    <td>{localizations.companyIndustryTypes[props.industryType]}</td>
                </tr>
                : null }
                {props.description ?
                <tr>
                    <td className="title">{localizations.company.companyDescription}</td>
                    <td>{props.description}</td>
                </tr>
                : null }
            </tbody>
        </table>
    );
}

const CompanyContactInfo = (props: CompanyCardProps) => {
    return (
        <table>
            <tbody>
            {props.emailContacts.map((item, index) =>
                <tr key={index}>
                    <td className="title">{localizations.common.email} {index + 1}:</td>
                    <td>
                        {toEmail(item.email || "")}
                        {item.emailDetails && item.emailDetails.length > 0 ? <span><i>{item.emailDetails}</i></span> : null}
                    </td>
                </tr>
            )}
            {props.phoneContacts.map((item, index) =>
                <tr key={index}>
                    <td className="title">{localizations.common.phoneNumber} {index + 1}:</td>
                    <td>
                        <span>{item.phoneNumber}<br /></span>
                        {item.phoneDetails && item.phoneDetails.length > 0 ? <span><i>{item.phoneDetails}</i></span> : null}
                    </td>
                </tr>
            )}
            <tr>
                <td className="title">
                    <CompanyActivityMark isCompany={false} level={props.announcementCount} />
                </td>
                <td>{localizations.common.announcementShortCount} {props.announcementCount}</td>
            </tr>
            </tbody>
        </table>
    );
}

const toEmail = (email: string) => <span><a href={"mailto: " + email}>{email}</a><br /></span>

const CompanyCard: React.SFC<CompanyCardProps> = (props) => {
        const { businessId } = props;
        return (
            <Grid container xs={12}>
                <Grid item style={{ marginBottom: 10 }} xs={12}>
                    <Grid container direction="row" spacing={2} xs={12}>
                        <Grid item container xs={6}>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography paragraph variant="subtitle1">{localizations.company.companyDetails}</Typography>
                                </Grid>
                                <Grid item>
                                    <CompanyInfo {...props} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} style={{paddingLeft:15}}>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography paragraph variant="subtitle1">{localizations.company.contacts}</Typography>
                                </Grid>
                                <Grid item>
                                    <CompanyContactInfo {...props} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <ZeckitLargeWidget businessId={businessId}/>
                </Grid>
            </Grid>
        );
    
}

const mapStateToProps = (state: ApplicationState) => {
}


export default connect<any, any, any>(mapStateToProps)(CompanyCard);


// WEBPACK FOOTER //
// ./src/map/CompanyCard.tsx